import { render } from "./SideBarCategory.vue?vue&type=template&id=2ba6a880"
import script from "./SideBarCategory.vue?vue&type=script&lang=js"
export * from "./SideBarCategory.vue?vue&type=script&lang=js"

import "./SideBarCategory.vue?vue&type=style&index=0&id=2ba6a880&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__